<template>
  <v-simple-table class="table-layout pa-4" style="height: calc(100vh - 280px) !important;overflow-y: auto !important;">
    <template v-slot:default>
      <thead>
        <tr>
          <th>Mã đơn hàng</th>
          <th>Ngày mua hàng</th>
          <th>Trạng thái</th>
          <th>Hình thức thanh toán</th>
          <th>Sản phẩm</th>
          <th>Số lượng</th>
          <th>Nhân viên kinh doanh</th>
          <th>Chiết khấu (%)</th>
          <th>Tổng tiền</th>
          <th>Thao tác</th>
        </tr>
      </thead>
      <template v-for="order in orders">
        <tbody class="bg-hover" :key="order.id">
          <tr>
            <td :rowspan="order.rowspan">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <b
                    style="font-weight:500;cursor:pointer"
                    @click="clickDetailOrder(order)"
                    v-on="on"
                  >
                    {{order.code}}
                  </b>
                </template>
                <span>Xem chi tiết thông tin đơn hàng</span>
              </v-tooltip>
            </td>
            <td :rowspan="order.rowspan">{{formatDate(order.createdAt)}}</td>
            <td :rowspan="order.rowspan">
              <v-autocomplete
                  class="filter-store pt-0"
                  v-model="order.statusId"
                  :items="contactStatusAgency"
                  item-text="name"
                  item-value="id"
                  @change="updateOrderAgency(order)"
              />
            </td>
            <td :rowspan="order.rowspan">{{_.get(order, 'paymentType', '')}}</td>
            <td>
              {{_.get(order, 'products[0].name', '')}}
            </td>
            <td>{{_.get(order, 'products[0].quantity', 0)}}</td>
            <td :rowspan="order.rowspan">{{_.get(order, 'userAgency.fullName', '')}}</td>
            <td :rowspan="order.rowspan">{{_.get(order, 'discount', '')}}%</td>
            <td :rowspan="order.rowspan">{{formatPrice(_.get(order, 'totalPrice', 0))}}</td>
            <td :rowspan="order.rowspan">
              <div class="action">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn @click="clickDetailOrder(order)" class="mr-2" icon small color="primary" v-on="on">
                      <v-icon>mdi-file-document</v-icon>
                    </v-btn>
                  </template>
                  <span>Xem chi tiết thông tin đơn hàng</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="exportActiveCodeForOrder(order.id)"
                      v-if="checkAuthorization('agency-user_read') || checkAuthorization('agency-admin_read')"
                      class="mr-2"
                      icon small
                      color="primary"
                      v-on="on"
                    >
                      <v-icon>mdi-microsoft-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>Tải xuống DS Mã kích hoạt của đơn</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="getActiveCode(order)"
                      v-if="order.statusId !== 5 && order.statusName !== 'Đã hủy' && checkAuthorization('agency-admin_read')"
                      class="mr-2"
                      icon small
                      color="blue"
                      v-on="on"
                    >
                      <v-icon>mdi-printer</v-icon>
                    </v-btn>
                  </template>
                  <span>In mã đơn hàng</span>
                </v-tooltip>
              </div>
            </td>
          </tr>
          <template v-for="(dataProduct, index) in order.products">
            <tr v-if="index > 0" :key="order.id + 'product-list' + index">
              <td>
                {{_.get(dataProduct, 'name', '')}}
              </td>
              <td>{{_.get(dataProduct, 'quantity', 0)}}</td>
            </tr>
          </template>
        </tbody>
      </template>
      <tfoot>
        <tr>
          <td colspan="7">
            <div style="margin-right: 20px;" class="d-flex align-center justify-end">
              <h3 class="mr-6">TỔNG GIÁ TRỊ ĐƠN HÀNG:</h3> <span>{{formatPrice(totalPrice)}}</span>
            </div>
          </td>
        </tr>
      </tfoot>
    </template>
  </v-simple-table>
</template>
<script>
import moment from "moment";
import AgencyRepository from "../../../repositories/AgencyRepository";
import { downloadFile } from "../../../helpers/utils";

export default {
  data() {
    return {
      filterForm: {}
    }
  },
  props: {
    orders: {
      type: Array,
      default: () => []
    },
    totalPrice: {
      type: [Number, String],
      default: 0,
    },
    contactStatusAgency: {
      type: Array,
      default: () => []
    }
  },
  created() {
    Bus.$on('order-list-filter', (filterForm) => {
      this.filterForm = filterForm
    })
  },
  methods: {
    clickDetailOrder(order) {
      // this.$router.push({
      let route = this.$router.resolve({
        name: 'AgencyOrderEdit',
        params: {
          id: order.agency.id,
        },
        query: {
          orderId: order.id,
        },
      });
      window.open(route.href, '_blank')
    },
    clickDetailCustomer(CustomerId) {
      let route = this.$router.resolve({
        name: 'DetailAgency',
        params: {
          id: CustomerId,
        },
      });
      window.open(route.href, '_blank')
    },
    dataStatus(item) {
      return `${_.get(item, 'statusId', '')}-${_.get(
          item,
          'paymentType',
          ''
      )}`;
    },
    async exportActiveCodeForOrder(id) {
      this.appLoadingData(true);
      const res = await AgencyRepository.exportActiveCodeForOrder(id);
      this.appLoadingData(false)
      if (res.data && res.data.success) {
        this.$swal({
          text: 'Tải xuống dữ liệu thành công!',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success'
        })
        await downloadFile(_.get(res, 'data.data.csvFile', ''), _.get(res, 'data.data.fileName', ''));
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
      }
    },
    formatDate(value) {
      if (value)
        return moment(value).format("DD-MM-YYYY")
    },
    async updateOrderAgency(order) {
      const orderId = order.id;
      let dataUpdate = {
        statusId: order.statusId,
        shippingAddress: {
          tinhId: _.get(order, 'tinhId', ''),
          huyenId: _.get(order, 'huyenId', ''),
          xaId: _.get(order, 'xaId', ''),
          detailAddress: _.get(order, 'detailAddress', '')
        }
      }

      this.appLoadingData(true)
      const response = await AgencyRepository.updateOrder(orderId, dataUpdate)
      this.appLoadingData(false)
      if (response.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      } else {
        this.$swal({
          title: 'Cập nhật đơn hàng thành công!',
          confirmButtonText: 'Đồng ý',
        }).then(() => {
          Bus.$emit('order-tab-filter', {})
        });
      }
    },
    async getActiveCode(order) {
      let activeCodeList = []
      const params = {
        agencyId: order.agency.id,
        orderAgencyId: order.id,
        typeOfCode: 2, // Mã đại lý
        productId: this.filterForm.productId,
        page: 0,
        limit: 1000
      }
      const res = await AgencyRepository.listActiveCode(params)
      if (res.success) {
        activeCodeList = _.get(res, 'data', [])
        this.printActiveCode(activeCodeList)
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    },
    printActiveCode(activeCodeList) {
      Bus.$emit('print-code-in-order', activeCodeList);
    }
  }
};
</script>

<style scoped>
/deep/ tbody td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

</style>